<template>
	<li
		@click="activateCard(store.id)"
		class="store-card"
		:class="{ active }"
	>
		<ECommerceStoreCardHeader
			:store="store"
			:active="active"
		/>
		<div
			class="content"
			:class="{ active }"
			v-if="active"
		>
			<EcommmerceClickAndCollectStoreRow
				:store="store"
				@reserve="selectStore"
				:disabled="!active"
			/>
		</div>
	</li>
</template>

<script>
export default defineNuxtComponent({
	name: "ECommerceClickAndCollectStoreCard",

	props: {
		store: {
			type: Object,
			required: true,
		},
		activeStoreId: {
			type: String,
		},
		buttonText: {
			type: String,
			required: true,
		},
	},

	computed: {
		active() {
			return this.store.id === this.activeStoreId;
		},
	},

	methods: {
		activateCard(id) {
			this.$emit("card-activated", id);
		},
		selectStore() {
			this.$emit("store-selected", this.store);
		},
	},
});
</script>

<style lang="scss" scoped>
.store-card {
	&.active {
		background-color: $color-neutrals-50-tint;
	}
	border-bottom: 1px solid;
	border-bottom-color: $color-neutrals-300-tint;
	padding: 16px 0;
	.header {
		margin: 8px;
	}

	&:not(.active) {
		cursor: pointer;
	}
}
</style>
